import type {MRT_Row} from "material-react-table";
import {APIModelAliasReference} from "@visorpro/client";
import {observer} from "mobx-react-lite";

export interface RegisteredModelCellProps {
    row: MRT_Row<APIModelAliasReference>
}
export const StatusCell = observer<RegisteredModelCellProps>(({row}) => {
    console.log(JSON.stringify(row.original))
    return <span>Status</span>;
});
